import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-anchor',
  templateUrl: './anchor.component.html',
  styleUrls: ['./anchor.component.scss'],
})
/**
 * Anchor atom
 */
export class AnchorComponent {
  @Input() routerLink!: string;
  private _thin: boolean = false;

  /**
   * If anchor is thin or not
   */
  @Input()
  get thin(): boolean {
    return this._thin;
  }

  /**
   * Sets anchor as thin
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set thin(value: any) {
    this._thin = coerceBooleanProperty(value);
  }
}
